export const handbookCopy = {
  handb_prev: "Previous",
  handb_next: "Next",
}
